<template>
  <div class='program-info-wrap' v-if = 'unit'>
    <h2> {{informationType}} Information </h2>
    <p class="program-info">
      <code v-html='programInfo' class='program-info'></code>
    </p>
    <p v-if = 'onlineAvailability'><b>Online Availability:</b> {{ onlineAvailability }}</p>
    <hr>
  </div>
</template>

<script>

// const defaultCareerData = { occupations: [] }

export default {
  name: 'ProgramInformation',

  data() {
    return {
    }
  },

  computed: {
    unit() {
      return this.$store.state.unit
    },
    informationType() {
      return this.unit.type
    },
    programInfo() {
      return this.unit.description
    },
    onlineAvailability() {
      return this.unit.online_availability
    },
    planName() {
      if (typeof this.unit.concentration === 'undefined') {
        return this.unit.program.name
      } else {
        return this.unit.program.name + ': ' + this.unit.concentration.name
      }
    },
    planType() {
      return (this.unit.concentration ? 'Concentration' : 'Program')
    }
  },

  methods: {
  }
}

</script>



// WEBPACK FOOTER //
// program_information.vue?1c224502